{
  "toast": {
    "companyCreated": "Company created",
    "storeCreated": "Store created",
    "warehouseCreated": "Warehouse created",
    "workCalendarConfigured": "Work calendar configured",
    "departmentCreated": "Department created",
    "enterpriseSetupComplete": "Enterprise setup complete",
    "onboardingCompleted": "Onboarding completed",
    "productCreated": "Product created",
    "customerCreated": "Customer created",
    "productsSaved": "Products saved"
  },
  "errors": {
    "createOrSelectAWeekPattern": "Create or select a week pattern",
    "failedToCreateCompany": "Failed to create company",
    "failedToCreateStore": "Failed to create store",
    "failedToCreateWarehouse": "Failed to create warehouse",
    "failedToLoadWeekPatterns": "Failed to load week patterns",
    "failedToSaveCalendar": "Failed to save calendar",
    "failedToCreateDepartment": "Failed to create department",
    "unableToCompleteOnboardingPleaseReviewDetailsAnd": "Unable to complete onboarding. Please review details and retry.",
    "storeNameAndCodeAreRequired": "Store name and code are required",
    "productNameIsRequired": "Product name is required",
    "customerNameIsRequired": "Customer name is required",
    "failedToCreateProduct": "Failed to create product",
    "failedToCreateCustomer": "Failed to create customer",
    "selectAtLeastOneProductToContinue": "Select at least one product to continue",
    "couldNotSaveYourProductSelectionPleaseTry": "Could not save your product selection. Please try again."
  },
  "pages": {
    "enterpriseSetup": "Enterprise setup",
    "organizationCompanyStoreWarehouseCalendarHr": "Organization → Company → Store → Warehouse → Calendar → HR → Finance → Go Live",
    "setUpPointOfSale": "Set up Point of Sale",
    "completeTheseStepsToStartSelling": "Complete these steps to start selling"
  },
  "labels": {
    "companyName": "Company name",
    "code": "Code",
    "storeName": "Store name",
    "storeCode": "Store code",
    "warehouseName": "Warehouse name",
    "warehouseCode": "Warehouse code",
    "assignWeekPattern": "Assign week pattern",
    "departmentName": "Department name",
    "departmentCode": "Department code",
    "organizationName": "Organization name",
    "organizationType": "Organization type",
    "industry": "Industry",
    "logoUrl": "Logo URL",
    "themeMode": "Theme mode",
    "productName": "Product name",
    "sku": "SKU",
    "price": "Price",
    "customerName": "Customer name",
    "phone": "Phone"
  },
  "listActions": {
    "openPosTerminal": "Open POS terminal"
  }
}
